import React, { useRef, useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, DrawingManager, Polygon } from "@react-google-maps/api";
import { useGoogleMaps } from "./GoogleMapsProvider";

const MapComponent = ({ selectedLatLng, onPolygonCompleted, resetTrigger, polygon }) => {
   const { isLoaded, loadError } = useGoogleMaps();
  const polygonRef = useRef(null);
  const [center, SetCenter] = useState({ lat: 37.7749, lng: -122.4194, });

  useEffect(() => {
    if (selectedLatLng && Object.keys(selectedLatLng).length == 2) {
        SetCenter(selectedLatLng)
    }
  }, [selectedLatLng])


  // Define container style and map center coordinates
  const containerStyle = {
    width: "100%",
    height: "400px",
  };



  // Load Google Maps API with useJsApiLoader
  // const { isLoaded, loadError } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY, // Environment variable for API Key
  //   libraries: ["drawing", "places", "geometry"], // Additional libraries
  // });


  const onPolygonComplete = (newPolygon) => {
    const polygonPath = newPolygon.getPath().getArray().map((latLng) => ({
      lat: latLng.lat(), // Extract latitude
      lng: latLng.lng(), // Extract longitude
    }));
    onPolygonCompleted(polygonPath);
  };


   const onCircleComplete = (circle) => {
  //   const center = circle.getCenter();
  //   const radius = circle.getRadius();
  //   console.log("Circle Center:", { lat: center.lat(), lng: center.lng() });
  //   console.log("Circle Radius:", radius);
  //   onPolygonCompleted([{ lat: center.lat(), lng: center.lng(), radius:radius }]);
   };

   const onRectangleComplete =(rectangle) => {
  //   const bounds = rectangle.getBounds();
  //   const latLngArray = [
  //     { lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng() },
  //     { lat: bounds.getSouthWest().lat(), lng: bounds.getSouthWest().lng() },
  //   ];
  //   onPolygonCompleted(latLngArray);
  //   console.log("Rectangle Bounds LatLng array:", latLngArray);
  //   rectangle.setMap(null); // Optionally remove the rectangle from the map
   };



  if (loadError) {
    return <div>Error loading Google Maps API</div>; // Handle error
  }

  if (!isLoaded) {
    return <div>Loading...</div>; // Show loading indicator
  }

  return (
    <>
      {loadError ? (
        <div>Error loading Google Maps API</div>
      ) : isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={20}
        >
          <Polygon
            paths={polygon}
            options={{
              fillColor: "blue",
              fillOpacity: 0.4,
              strokeColor: "blue",
              strokeOpacity: 0.8,
              strokeWeight: 2,
            }}
          />
          <DrawingManager
            onPolygonComplete={onPolygonComplete}
            onCircleComplete={onCircleComplete}
            onRectangleComplete={onRectangleComplete}
            options={{
              drawingControl: true,
              drawingControlOptions: {
                drawingModes: ["polygon"],
              },
              polygonOptions: {
                fillColor: "#2196F3",
                fillOpacity: 0.5,
              },
            }}
          />
        </GoogleMap>
      ) : (
        <div>Loading...</div>
      )}
    </>
  );

};

export default MapComponent;
